<template>
  <div
    class="field RMPE-CustomField"
    :class="{ 'RMPE-HasError': fieldHasError }"
  >
    <div class="control is-expanded">
      <label
        class="label"
      >
        <span
          :class="{'RMPE-Required': question.required}"
          v-html="question.label"
        />
      </label>
      <div
        class="RMPE-StarRating"
      >
        <div class="RMPE-StarRating-rating">
          <div
            class="RMPE-StarRating-stars"
            :class="{ 'is-danger': fieldHasError }"
          >
            <div
              v-for="(star, index) in maxStars"
              :ref="index === 0 ? 'auto-focus-target' : null"
              :key="index"
              class="RMPE-StarRating-star"
              tabindex="0"
              @mouseover="mouseOver(index)"
              @mouseleave="mouseLeave"
              @keydown.space.prevent="handler(index)"
              @click="handler(index)"
              @blur="isBlurred = true"
            >
              <font-awesome :icon="star <= stars ? iconSolid : iconOutline" />
            </div>
          </div>
          <span
            v-if="showTotal"
            class="RMPE-StarRating-stats"
          >
            {{ roundedValue }}/{{ maxStars }}
          </span>
        </div>
        <div
          v-if="question.minLabel && question.maxLabel"
          class="RMPE-StarRating-help"
        >
          <span class="RMPE-StarRating-helper">
            <span class="RMPE-StarRating-figure">{{ question.minLabel }}</span>
          </span>
          <span class="RMPE-StarRating-helper">
            <span class="RMPE-StarRating-figure">{{ question.maxLabel }}</span>
          </span>
        </div>
      </div>
      <div class="select RMPE-MobileStarFallback">
        <select
          :id="`${fieldQuestionId}-mobile`"
          v-model="tempValue"
          :class="{ 'is-danger': fieldHasError }"
          @change="selectHandler"
          @blur="isBlurred = true"
        >
          <option
            v-for="(star, index) in maxStars"
            :key="index"
            :value="index + 1"
          >
            <span v-html="getStarString(index)" />
          </option>
        </select>
      </div>
      <error-message
        v-if="fieldHasError"
        :errors="error.errors"
        :is-blurred="isBlurred"
        :manual-validate="manualValidate"
      />
    </div>
  </div>
</template>

<script>
import StaticFieldMixin from '../../mixins/static-field-mixin';
import RatingFieldMixin from '../common/rating-field';

export default {
  mixins: [StaticFieldMixin, RatingFieldMixin],
};
</script>

<style lang="scss" scoped>
.RMPE-StarRating-rating {
  display: flex;
  align-items: center;
}

.RMPE-StarRating-help {
  display: flex;
  justify-content: space-between;
}

.RMPE-StarRating-helper {
  display: inline-block;
}

.RMPE-StarRating-figure {
  font-size: 70%;
}

.RMPE-StarRating-stars {
  display: inline-block;
  width: 100%;
  display: flex;
  align-items: center;
  border: 1px solid #000;

  &.is-danger {

  }
}
.RMPE-StarRating-star {
  flex: 1;
  text-align: center;
  padding: 10px;
  cursor: pointer;
}

.RMPE-MobileStarFallback {
  display: none;
}
.StarRating {
  display: block;
}

@media screen and (max-width: 700px) {
  .select {
    margin-right: 0;
    margin-bottom: 20px;
    width: 100%;

    select {
      width: 100%;
    }
  }

  .RMPE-MobileStarFallback {
    display: block;
  }
  .RMPE-StarRating {
    display: none;
  }
}

</style>
